import { jsxs as l, jsx as e, Fragment as ht } from "@emotion/react/jsx-runtime";
import { useRef as ut, useId as It, useState as M, useImperativeHandle as gt, useCallback as b } from "react";
import { CharacterCount as wt } from "./subComponents/Count/Count.js";
import { LeftClickableElement as xt } from "./subComponents/LeftClickableElement/LeftClickableElement.js";
import { Notice as Ct } from "./subComponents/Notice/Notice.js";
import { RightComponent as bt } from "./subComponents/RightComponent/RightComponent.js";
import { TextInputContainer as kt, InputContainer as vt, StyledRelativeDiv as Lt, StyledLeftIcon as Pt, InputField as Rt, getColorNotice as Dt, ResetButton as Nt, NoticeContainer as St } from "./TextInput.styled.js";
import { Icon as Vt } from "../Icon/index.js";
import { InputLabel as jt } from "../InputLabel/index.js";
import { Stack as k } from "../Stack/index.js";
import { LeftElementType as T } from "../../types/components/textinput.js";
import { FontAwesomeIconsPartooUsed as Bt, IconPrefix as Ft } from "../../types/components/icon.js";
const Qt = ({
  dataTrackId: s,
  className: U,
  name: v,
  label: L,
  placeholder: X,
  noTopLabel: _ = !1,
  value: a,
  type: r = "text",
  autoFocus: z,
  autoComplete: G = "off",
  generated: H,
  tabIndex: J,
  edit: K,
  required: Q = !1,
  readOnly: o = !1,
  disabled: i = !1,
  success: p = !1,
  error: n = !1,
  customColor: P,
  warning: R = !1,
  leftElement: d,
  leftElementType: m,
  unit: D,
  copy: N = !1,
  copyText: W,
  copiedText: Y,
  isDropdown: S = !1,
  valueContainer: V,
  notice: j,
  characterCount: h,
  hideInput: Z = !1,
  inputProps: y,
  hasOldTextFieldHeight: B = !1,
  isReset: O = !1,
  onReset: F,
  onBlur: u,
  onChange: $,
  onFocus: I,
  onKeyUp: tt,
  onKeyDown: et,
  ref: ot
}) => {
  const f = ut(null), g = `textinput-${It()}`, [w, q] = M(!1), [x, it] = M(!1), nt = !!d && !!m && m === T.Clickable, st = r === "password" && x ? "text" : r, E = Dt({
    error: n,
    warning: R,
    success: p
  }), at = !!n || !!h || !!j, c = !!L && !_, C = c && (K || w || a || n || H), rt = !c || !!C, A = !!(p || r === "password" || D || N);
  gt(ot, () => f.current);
  const ct = (t) => {
    t.preventDefault(), f.current && f.current.focus();
  }, lt = b((t) => $?.(t.target.value), [$]), dt = b((t) => {
    !w && !o && q(!0), I && I(t);
  }, [w, o, I]), ft = b((t) => {
    !t.target.value && q(!1), u && u(t);
  }, [u]), pt = (t) => {
    t.preventDefault(), F();
  }, mt = () => {
    it(!x);
  };
  return /* @__PURE__ */ l(kt, { "data-track": s, "data-readonly": o, "data-disabled": i, className: U, children: [
    /* @__PURE__ */ e(vt, { dataTrackId: s, "data-disabled": i, "data-readonly": o, "data-slate": P === "slate", "data-error": n, "data-warning": R, "data-success": p, onClick: ct, hasOldTextFieldHeight: B, children: /* @__PURE__ */ l(Lt, { children: [
      nt && /* @__PURE__ */ e(xt, { children: d }),
      /* @__PURE__ */ l(k, { gap: "8px", direction: "row", alignItems: "center", style: {
        position: "relative",
        width: "100%",
        padding: "8px 16px"
      }, children: [
        m === T.Icon && d && /* @__PURE__ */ e(Pt, { icon: d, color: "secondary" }),
        /* @__PURE__ */ l(k, { direction: "row", alignItems: "center", style: {
          position: "relative",
          width: S ? "calc(100% - 16px)" : "100%"
        }, children: [
          r === "dropdown" && !!V && /* @__PURE__ */ e(ht, { children: V }),
          !Z && /* @__PURE__ */ e(Rt, { ref: f, "data-track": s, id: g, "aria-label": c ? void 0 : v ?? g, as: "input", type: st, name: v, onReset: F, autoFocus: z, disabled: i, error: !!n, hasLabel: c, autoComplete: G, hasRightElement: A, isPlaceholderVisible: rt, onBlur: ft, onChange: lt, onFocus: dt, onKeyUp: tt, onKeyDown: et, placeholder: X, readOnly: o, tabIndex: o ? -1 : J, value: a, edit: !!C, ...o && {
            onClick: (t) => t.preventDefault()
          }, ...y }),
          c && /* @__PURE__ */ e(jt, { value: L, required: Q, dataTrackId: `label_${s}`, edit: !!C, disabled: i, readOnly: o, color: P ?? E, htmlFor: g, hasOldTextFieldHeight: B })
        ] }),
        A && /* @__PURE__ */ e(bt, { disabled: i, type: r, value: a, isPasswordVisible: x, togglePassword: mt, unit: D, isDropdown: S, readOnly: o, copy: N, copyText: W, copiedText: Y }),
        !!a && O && !o && /* @__PURE__ */ e(Nt, { children: /* @__PURE__ */ e(Vt, { onMouseDown: pt, dataTrackId: `reset-filters-${s}`, icon: [Bt.faCircleXmark, Ft.SOLID], color: "secondary" }) })
      ] })
    ] }) }),
    /* @__PURE__ */ e(St, { opened: at, children: /* @__PURE__ */ l(k, { direction: "row", justifyContent: "space-between", style: {
      padding: "4px 16px"
    }, children: [
      /* @__PURE__ */ e(Ct, { color: E, children: j }),
      h && /* @__PURE__ */ e(wt, { value: a, hasError: !!n, disabled: i, characterCount: h })
    ] }) })
  ] });
};
export {
  Qt as TextInput
};
